import { Light as ThreeLight } from "three";
import { Object3D } from '../Object3D'


class Light extends Object3D {

}

export default Light
